import { paths } from '@/app/router/paths';
import { routeRoles } from '@/app/router/roles';
import { hasRole, useSessionStore } from '@/shared/api';

import { surveyCopy } from '../copy';

export interface BackTarget {
    to: string;
    /** Voluit, voor een knop in een melding en voor de schermlezer: "Terug naar de keuring". */
    label: string;
    /** Kort, naast de pijl in de balk van de opname: "Keuring". */
    short: string;
}

/**
 * Waar je vanuit de opname of het energielabel naar terug gaat.
 *
 * Een inspecteur komt van Mijn dag en gaat daarheen terug: dat scherm werkt ook
 * offline, het overzicht van de keuring niet. Een eigenaar die niet zelf keurt
 * heeft geen Mijn dag en gaat terug naar de keuring. Wie meekijkt heeft geen
 * Mijn dag (die staat op het apparaat van de inspecteur); zonder bekende keuring
 * is dat de lijst Keuringen.
 */
export function useBackTarget(orderUuid: string | null): BackTarget {
    const field = useSessionStore((state) => hasRole(state.session, routeRoles.myDay));
    const impersonating = useSessionStore((state) => state.impersonation !== null);

    if (field && !impersonating) {
        return {
            to: paths.myDay,
            label: surveyCopy.load.backToMyDay,
            short: surveyCopy.header.backToMyDay,
        };
    }

    return orderUuid
        ? {
              to: paths.dossier(orderUuid),
              label: surveyCopy.load.backToOrder,
              short: surveyCopy.header.backToOrder,
          }
        : {
              to: paths.inspections,
              label: surveyCopy.load.backToOrders,
              short: surveyCopy.header.backToOrders,
          };
}
